"use client";

import { getLabel } from "@/data/labels";

interface TitleTagProps {
  content?: string;
  labelKey?: "LIVE_NEWS" | "PRINT_EDITION";
  size?: "sm" | "md";
}

/** Live / print badges stay in English on every locale (en-IN, te-IN, etc.). */
export default function TitleTag({ content, labelKey, size = "sm" }: TitleTagProps) {
  const display = labelKey ? getLabel("en", labelKey) : content ?? "";
  const colorClass =
    labelKey === "LIVE_NEWS"
      ? "bg-red-100 text-red-700"
      : labelKey === "PRINT_EDITION"
        ? "bg-blue-100 text-blue-700"
        : "bg-[#fdeced] text-primaryColor";

  const sizeClass =
    size === "md"
      ? "gap-2 px-3 py-2 text-[13px] sm:text-sm mr-0 mb-0"
      : "gap-1.5 px-[6px] py-1 text-[10px] mr-1 mb-1";

  const baseClass = `inline-flex items-center rounded font-sans uppercase font-semibold leading-none align-middle ${sizeClass}`;

  if (labelKey === "LIVE_NEWS") {
    return (
      <span className={`${baseClass} ${colorClass}`}>
        <span
          className={`live-news-dot shrink-0 ${size === "md" ? "live-news-dot--md" : ""}`}
          aria-hidden
        />
        <span>{display}</span>
      </span>
    );
  }

  return (
    <span className={`${baseClass} ${colorClass}`}>
      {display}
    </span>
  );
}
